export default "__VITE_ASSET__CshGeMin__"